import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { combineLatest, of } from 'rxjs';
import { catchError, first, switchMap } from 'rxjs/operators';

import { selectCompanyId, selectUser } from '@rpt-ngrx/selectors/session.selector';
import { CustomHttpClient } from '@services/http-client';

import { ILogExportRequest } from './models/export-logger.model';

@Injectable({
    providedIn: 'root',
})
export class LoggerService {
    constructor(
        private http: CustomHttpClient,
        private store: Store,
    ) {}

    /**
     * Log export action to the backend
     * @param {'CSV' | 'XLSX' | 'PDF'} exportFormat Export format
     * @param {string} reportName Report title/type
     * @param {string} reportId Report ID
     * @returns {void}
     */
    public logExport(exportFormat: 'CSV' | 'XLSX' | 'PDF', reportName: string, reportId: string): void {
        combineLatest([this.store.select(selectUser), this.store.select(selectCompanyId)])
            .pipe(
                first(([user, companyId]) => !!user && !!companyId),
                switchMap(([user, companyId]) => {
                    const headers = new HttpHeaders({
                        'x-company-id': companyId,
                    });

                    const body: ILogExportRequest = {
                        userId: user.id,
                        reportId: reportId,
                        reportName: reportName,
                        exportFormat: exportFormat,
                    };

                    return this.http.post<void>('/log-export', body, { headers });
                }),
                catchError((error) => {
                    console.warn('Export logging failed:', error);
                    return of(null);
                }),
            )
            .subscribe();
    }
}
